import OBase from './OBase';
import * as Geometry from '../geometry';

export default class ReplacePaths extends OBase {
  update () {
    let inputDataTree = this.getObjectInput('Data');
    let inputSearchTree = this.getStringInput('Search');
    let inputReplaceList = this.getStringInput('Replace');

    let output = this.outputs['Data'].paramObject;

    let tree = ReplacePaths.replacePaths(inputDataTree, inputSearchTree, inputReplaceList);

    output.value = tree;
  }

  static replacePathString (pathString) {
    let path = pathString.replace('{', '');
    path = path.replace('}', '');
    return path;
  }

  static createGHPathFromString (pathString) {
    let ghpath = new Geometry.GHPath(pathString);
    return ghpath;
  }

  static replacePaths (inputDataTree, inputSearchTree, inputReplaceList) {
    let search = '';
    for (let i = 0; i < inputSearchTree.branches.length; i++) {
      for (let j = 0; j < inputSearchTree.branches[i].length; j++) {
        search = inputSearchTree.branches[i][j];
      }
    }
    search = ReplacePaths.replacePathString(search);

    let replace = '';
    for (let i = 0; i < inputReplaceList.branches.length; i++) {
      for (let j = 0; j < inputReplaceList.branches[i].length; j++) {
        replace = inputReplaceList.branches[i][j];
      }
    }
    replace = ReplacePaths.replacePathString(replace);

    let tree = new Geometry.DataTree();
    for (let i = 0; i < inputDataTree.branches.length; i++) {
      let ghpath = inputDataTree.paths[i];
      let ghpathString = ghpath.toString();
      if (search !== ghpathString) {
        for (let j = 0; j < inputDataTree.branches[i].length; j++) {
          let inputObj = inputDataTree.branches[i][j];
          tree.add(inputObj, ghpath);
        }
      } else {
        ghpath = ReplacePaths.createGHPathFromString(replace);
        for (let j = 0; j < inputDataTree.branches[i].length; j++) {
          let inputObj = inputDataTree.branches[i][j];
          tree.add(inputObj, ghpath);
        }
      }
    }

    return tree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ReplacePaths.js